import { Bytes as BytesUnit } from "@/utils/unit";

/**
 * Format bytes to KB, MB or GB with appropriate suffix
 * @param bytes - The number of bytes to format
 * @returns The formatted string with KB, MB or GB suffix
 */
export const formatBytes = (bytes: number): string => {
  const KB = 1024;
  const MB = KB * KB;
  const GB = MB * KB;

  if (bytes >= GB) {
    const sizeInGB = BytesUnit.gigabytes(bytes);
    return `${sizeInGB.toLocaleString("da-DK", {
      style: "decimal",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })} GB`;
  } else if (bytes >= MB) {
    const sizeInMB = BytesUnit.megabytes(bytes);
    return `${sizeInMB.toLocaleString("da-DK", {
      style: "decimal",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })} MB`;
  } else {
    const sizeInKB = BytesUnit.kilobytes(bytes);
    return `${sizeInKB.toLocaleString("da-DK", {
      style: "decimal",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    })} KB`;
  }
};
